import { render, staticRenderFns } from "./SelflaneRevIcon.vue?vue&type=template&id=66d92358&scoped=true"
var script = {}
import style0 from "./SelflaneRevIcon.vue?vue&type=style&index=0&id=66d92358&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d92358",
  null
  
)

export default component.exports